(function () {
    $(document).ready(function() {
        "use strict";

        // Remove legacy share callout cookie
        if (Cookies.get('callout')) {
            Cookies.remove('callout');
        }

        /* Sets the popup position based on selection position */
        function setPosition() {
            var range = selection.getRangeAt(0);
            var rects = range.getClientRects();
            var top = ($(window).scrollTop() + rects[0].top ) - ($entry.offset().top ) -   ($highlight.height() + 23);
            var left = (rects[0].left - $entry.offset().left ) + (rects[0].width/2) - $highlight.width()/2;
            $highlight.css({top:top, left: left});
        }

        /* This function hides pop up */
        function hidePopup(e) {
            if (!$(e.target).is('#highlight-share__popup, #highlight-share__popup *')) {
                $highlight.hide();
                detachEvents();
            }
        }

        /* Attaching events when the popup is shown */
        function attachEvents() {
            /* Apply the higlight logic after window resize */
            $( window ).resize(setPosition);

            /* Clicking any where except the popup */
            $body.on('mousedown', hidePopup);
        }

        /* Deatch events when the popup is hidden */
        function detachEvents() {
            /* Apply the higlight logic after window resize */
            $( window ).off('resize', setPosition);

            /* Clicking any where except the popup */
            $body.off('mousedown', hidePopup);
        }

        /* Run for wide screens only (Desktop) */
        if ($(window).width() > 736) {

            var $body = $('body');
            var $entry = $('.entry__content');
            var $highlight = $('#highlight-share__popup');
            var $facebook = $highlight.find('.facebook');
            var $twitter = $highlight.find('.twitter');
            var url = encodeURI(window.location.href);
            var lastHighlightedText;
            var selection;
            /* From twitter docs: A URL of any length will be altered to 23 characters, even if the link itself is less than 23 characters long.
             *  So, we have only 140 - 23 - 1(space char) = 116 chars available.
            */
            var twitterLength = 116;

            /* This function handles the logic for showing the popup after selecting text */
            var highlightPopup = function(event) {

                // Add class 'disable-highlight-popup' to elements
                // you want to disable highlight popups on.
                if ( $(event.target).hasClass('disable-highlight-popup') ) {
                  return;
                }

                selection = window.getSelection();

                var highlightedText = selection.toString().trim();
                if(highlightedText && highlightedText != lastHighlightedText) {

                    /* Show highlight popup*/
                    $highlight.show();
                    /* Attach events on mousedown and window resize */
                    attachEvents();
                    /* Set pop up position above the selected text */
                    setPosition();
                    /* Update hrefs for facebook and twitter with the selected text */
                    $twitter.attr('href', 'https://twitter.com/share?url=' + url + '&text=' + encodeURI(highlightedText.substring(0,twitterLength)));
                    $facebook.attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + url + '&description=' + encodeURI(highlightedText));

                    lastHighlightedText = highlightedText;

                    MW.events.publish('highlighted_text', highlightedText);
                }
            };

            /* Mouse up event after selecting text */
            $entry.on('mouseup', highlightPopup);
        }
      });
}) ();
